// Mock data for AmruthAI website

export const companyInfo = {
  name: "AmruthAI",
  tagline: "Transforming Businesses with Intelligent AI Solutions",
  description: "We are a leading IT startup specializing in cutting-edge AI solutions that drive business growth and innovation.",
  logo: "https://customer-assets.emergentagent.com/job_ef1f86f3-b3cc-4db9-b173-46d768337880/artifacts/elsah9on_ChatGPT%20Image%20Dec%209%2C%202025%2C%2001_17_24%20PM.png",
  email: "contact@amruthai.com",
  phone: "+91 9440203095",
  address: "Chennai, Tamil Nadu, India",
  founded: 2023,
  socialLinks: {
    linkedin: "https://linkedin.com/company/amruthai",
    twitter: "https://twitter.com/amruthai",
    github: "https://github.com/amruthai"
  }
};

export const services = [
  {
    id: "web-development",
    title: "Web Development",
    description: "Build modern, responsive, and high-performance websites and web applications tailored to your business needs.",
    icon: "Globe",
    features: ["Custom Website Development", "E-commerce Solutions", "Progressive Web Apps", "CMS Development"]
  },
  {
    id: "app-development",
    title: "App Development",
    description: "Create powerful mobile applications for iOS and Android platforms that deliver exceptional user experiences.",
    icon: "Smartphone",
    features: ["iOS App Development", "Android App Development", "Cross-Platform Apps", "App Maintenance & Support"]
  },
  {
    id: "ai-automations",
    title: "AI Automations",
    description: "Intelligent automation powered by AI to streamline operations, reduce costs, and eliminate repetitive tasks.",
    icon: "Bot",
    features: ["Process Automation", "Intelligent Document Processing", "Chatbots & Virtual Assistants", "Workflow Optimization"]
  },
  {
    id: "ai-ml",
    title: "AI/ML Solutions",
    description: "Custom machine learning models designed to solve your specific business challenges with cutting-edge AI technology.",
    icon: "Cpu",
    features: ["Custom Model Development", "Predictive Analytics", "Natural Language Processing", "Computer Vision"]
  },
  {
    id: "ai-consulting",
    title: "AI Consulting",
    description: "Strategic AI implementation guidance tailored to your business needs. We help you identify opportunities and create a roadmap for AI integration.",
    icon: "Brain",
    features: ["AI Strategy Development", "Technology Assessment", "Implementation Roadmap", "ROI Analysis"]
  }
];

export const stats = [
  { value: "50+", label: "Projects Delivered" },
  { value: "30+", label: "Happy Clients" },
  { value: "15+", label: "AI Solutions" },
  { value: "99%", label: "Client Satisfaction" }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Rajesh Kumar",
    role: "CEO & Founder",
    bio: "Former Google AI researcher with 15+ years of experience in machine learning.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "CTO",
    bio: "Expert in distributed systems and cloud architecture. Previously at Amazon.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Michael Chen",
    role: "Head of AI Research",
    bio: "PhD in Computer Science from MIT. Specialist in deep learning and NLP.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Sarah Williams",
    role: "VP of Engineering",
    bio: "10+ years leading engineering teams at top tech companies.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "AmruthAI transformed our customer service with their intelligent chatbot solution. Response times dropped by 70% and customer satisfaction soared.",
    author: "James Wilson",
    company: "TechCorp Industries",
    role: "CEO"
  },
  {
    id: 2,
    quote: "Their machine learning models helped us predict market trends with remarkable accuracy. Our ROI increased by 150% in just six months.",
    author: "Emily Rodriguez",
    company: "FinanceHub",
    role: "Director of Analytics"
  },
  {
    id: 3,
    quote: "The team at AmruthAI is exceptional. They understood our needs perfectly and delivered a solution that exceeded our expectations.",
    author: "David Park",
    company: "HealthPlus",
    role: "CTO"
  }
];

export const faqs = [
  {
    question: "What industries do you serve?",
    answer: "We serve a wide range of industries including healthcare, finance, retail, manufacturing, and technology. Our AI solutions are customizable to meet the specific needs of any sector."
  },
  {
    question: "How long does it typically take to implement an AI solution?",
    answer: "Implementation timelines vary based on project complexity. Simple solutions can be deployed in 4-6 weeks, while more complex enterprise solutions may take 3-6 months. We provide detailed timelines during our initial consultation."
  },
  {
    question: "Do you offer ongoing support after deployment?",
    answer: "Yes, we offer comprehensive support packages that include monitoring, maintenance, updates, and continuous improvement of your AI solutions. Our team is available 24/7 for critical issues."
  },
  {
    question: "How do you ensure data security and privacy?",
    answer: "We follow industry-leading security practices including encryption, secure data handling, and compliance with regulations like GDPR and HIPAA. Your data security is our top priority."
  }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxBSSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzY1MjUyNTAzfDA&ixlib=rb-4.1.0&q=85",
  aiBrain: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxBSSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzY1MjUyNTAzfDA&ixlib=rb-4.1.0&q=85",
  ai3d: "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxBSSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzY1MjUyNTAzfDA&ixlib=rb-4.1.0&q=85",
  office1: "https://images.unsplash.com/photo-1748346918817-0b1b6b2f9bab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc2NTI2NzA2Mnww&ixlib=rb-4.1.0&q=85",
  office2: "https://images.unsplash.com/photo-1758518725921-1eb74ed293be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc2NTI2NzA2Mnww&ixlib=rb-4.1.0&q=85",
  office3: "https://images.unsplash.com/photo-1758876021720-339f804ae92d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc2NTI2NzA2Mnww&ixlib=rb-4.1.0&q=85"
};
